import React from "react";
import { StyledHtml } from "@postenbring/hedwig-react";

import "./wysiwyg-tmp-override.scss";

export const Wysiwyg = ({ text }) => {
  const markUp = { __html: text };

  return <StyledHtml dangerouslySetInnerHTML={markUp} className="hds-mb-20-24"></StyledHtml>;
};
